import styled from 'styled-components';

interface Props {
  $imageHeight?: string;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-self: flex-start;
`;

export const Title = styled.span`
  font-weight: 500;
  font-size: 22px;
  color: white;
`;

export const Description = styled.span`
  font-size: 14px;
  color: white;
`;

export const Image = styled.img<Props>`
  height: ${props => props.$imageHeight || 'auto'};
`;
